<template>
  <div class="t-28 fw-7 onyx"> {{ props.poll.title }} </div>
  <BaseBreadcrumbs :crumbs="[{ label: 'Polls', path: '/polls' }]" class="m-tx4" />
  <BaseBanner class="m-tx2 m-bx2" copy="The voting interface has been updated to allow voters to leave options unranked."/>
  <InputsToggle class="m-bx2" v-model="useOldInterface" label="Use old interface" />
  <form :action="`/polls/${props.poll.id}/poll_votes`" method="post" class="f-v m-tx4">
    <input
      v-model="voterName"
      class="input-text w-x60"
      type="text"
      name="poll_votes[voter_name]"
      placeholder="Your name here..."
      maxlength="12"
    >
    <input
      class="input-text w-x60 m-tx4"
      type="text"
      name="poll_votes[pin]"
      placeholder="PIN [optional]"
    >
    <img
      v-if="props.poll.image_url"
      :src="props.poll.image_url"
      class="w-x63 m-tx4 br-4"
    />
    <PollsVoteOrdered v-if="useOldInterface" :poll="props.poll" />
    <PollsVoteRanked v-else :poll="props.poll" @update-rankings-are-valid="updateRankingsAreValid" />
    <input type="submit" value="Submit" :class="`button w-x20 m-tx6 ${formIsValid ? '' : 'disabled'}`">
  </form>
</template>

<script setup>
  import { ref, computed } from 'vue';

  const props = defineProps(['poll']);

  const voterName = ref('');
  const useOldInterface = ref(false);

  // Form Validity
  const voterNameIsValid = computed(() => voterName.value.trim().length);
  const rankingsAreValid = ref(false);
  const formIsValid = computed(() => {
    if (useOldInterface.value) return voterNameIsValid.value;
    return voterNameIsValid.value && rankingsAreValid.value;
  });
  const updateRankingsAreValid = (isValid) => {
    rankingsAreValid.value = isValid;
  };
</script>